export default __webpack_public_path__ + "static/media/service-4-handyman.aadcea3f.png";